import styled from "styled-components";

export const FilterByBox = styled.span`
  ${({theme}) => theme.font.size.large}
  margin-bottom: 2rem;
  display: block;
`;